<template>
  <div class="header container no-print" :class="{ marginL50: isToggle }">
    <!--上头部-->
    <div class="header-wrap clearfix">
      <!--显示侧边栏按钮-->
      <div class="header-show-btn w47 h47 fl">
        <button class="header-show-btn-wrap" @click="toggleSideBar">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <!--右侧菜单栏-->
      <div class="header-content clearfix h47">
        <!--前进后退按钮-->
        <div class="fl marginL10 router-btn-wrap">
          <button class="router-btn h47" @click="preClick">&lt;</button>
          <button class="router-btn h47" @click="nextClick">&gt;</button>
        </div>
        <!--<div class="fl marginL10">-->
        <!--<img src="../../../images/zb-icon.png" class="marginR20 marginL20 header-logo" >-->
        <!--<img src="../../../images/zdff-icon.png" class="header-logo"/>-->
        <!--</div>-->
        <!--搜索按钮-->
        <!--<div class="header-search-wrap clearfix marginL10 fl">
                    <input
                            type="search"
                            class="header-search-input fontSize12 fl"
                            @blur="isFocus=false"
                            placeholder="请输入您要搜索的内容"
                            v-focus="isFocus"
                    >
                    <button class="header-search-btn fl" @click="getFocus"/>
        </div>-->
        <!--右侧菜单-->
        <ul class="header-content-list clearfix">
          <!--<li class="header-content-item ghost-btn-wrap">-->
          <!--<el-tooltip class="item" effect="dark" :content="version" placement="left-start">-->
          <!--<el-button-->
          <!--size="small"-->
          <!--type="ghost"-->
          <!--style="padding:7px 20px;"-->
          <!--@click="Downloading"-->
          <!--class="ghost-btn">-->
          <!--<svg class="icon fontSize12" aria-hidden="true">-->
          <!--<use xlink:href="#icon-xiazai"></use>-->
          <!--</svg>  视频客户端下载-->
          <!--</el-button>-->
          <!--</el-tooltip>-->
          <!--</li>-->
          <!--<li class="header-content-item">-->
          <!--<router-link class="header-content-link" to="/personalPage">-->
          <!--&lt;!&ndash;<img src="../../images/icon-person.png" alt="头像" class="icon-person">&ndash;&gt;-->
          <!--<img :src="userInfo.docAvatar?userInfo.docAvatar:require('../../../images/doc-default-icon.png')" class="header-personal-icon">-->
          <!--{{ userInfo.docName }}-->
          <!--</router-link>-->
          <!--</li>-->
          <li class="header-content-item">
            <el-dropdown>
              <span class="el-dropdown-link">
                联系客服
                <!--<svg class="icon fontSize12" aria-hidden="true">-->
                <!--<use xlink:href="#icon-kefu"></use>-->
                <!--</svg>-->
              </span>
              <el-dropdown-menu
                slot="dropdown"
                style="border-radius: 5px; overflow: hidden; padding: 0"
              >
                <div
                  class="header-yz"
                  style="width: 200px; height: 30px; border-radius: 5px"
                >
                  <!--<h1 style="text-align: left;">医助工作时间:</h1>-->
                  <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">8895120</p>-->
                  <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">（上午8:00-11:30）</p>-->
                  <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">（下午13:30-17:00）</p>-->
                  <div class="header-top">
                    <p style="font-size: 14px">{{ lxdh }}</p>
                    <!--<p style="font-size: 14px;">661888（院内）</p>-->
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!--<li class="header-content-item">-->
          <!--<span class="header-content-link" >-->
          <!--<el-dropdown @command="linkTo" trigger="click" >-->
          <!--<span class="hover-cursor gray-color" @click="dropDownHandler">-->
          <!--<el-badge :value="allMsgBoxListCounts" class="header-badge item" :max="99">-->
          <!--<svg class="icon fontSize16" aria-hidden="true">-->
          <!--<use xlink:href="#icon-xiaoxi"></use>-->
          <!--</svg>-->
          <!--&lt;!&ndash;<img src="../../images/icon-msg.png" alt="消息">&ndash;&gt;-->
          <!--</el-badge>-->
          <!--&lt;!&ndash;消息<i class="el-icon-caret-bottom el-icon&#45;&#45;right "></i>&ndash;&gt;-->
          <!--</span>-->
          <!--<el-dropdown-menu slot="dropdown" class="fontSize12" >-->
          <!--<el-dropdown-item :class="[item.isread?'clicked-item':'']" :command="JSON.stringify(item)" v-for="(item,index) in partMsgBoxList" :key="index">{{ '【'+ item.messageTitle + '】' + item.messageBody }}</el-dropdown-item>-->
          <!--<span v-show="partMsgBoxList.length!=0" class="hover-cursor fr marginR10" @click="showMsgListBox">更多>></span>-->
          <!--</el-dropdown-menu>-->
          <!--</el-dropdown>-->
          <!--</span>-->
          <!--<MsgListBoxCmp/>-->
          <!--</li>-->
          <li class="header-content-item">
            <router-link class="header-content-link" to="/setUp">
              <svg class="icon fontSize16" aria-hidden="true">
                <use xlink:href="#icon-shezhi"></use>
              </svg>
              <!--<img class=" icon-person" src="../../images/icon-set.png" alt="设置">-->
            </router-link>
          </li>
          <li class="header-content-item">
            <span class="logout-btn header-content-link" @click="logout">
              <svg class="icon fontSize18" aria-hidden="true">
                <use xlink:href="#icon-tuichu"></use>
              </svg>
              <!--<img src="../../images/icon-power.png" alt="退出/登录">-->
            </span>
          </li>
        </ul>
      </div>
    </div>
    <!--下头部-日期-->
    <div class="header-date clearfix">
      <div class="date fl marginL20">{{ showTime }}</div>
      <div class="router fr">
        <a class="router-home" @click="linkToHome">首页 ></a>
        <span class="router-other">{{ routerPath }}</span>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
import { systemService } from "../../../service/system";
import { MessageBox } from "element-ui";
import MsgListBoxCmp from "./MsgListBoxCmp.vue";
import axiosUtil from "../../utils/AxiosUtils.js";
import MsgBoxListUtils from "../../utils/MsgBoxListUtils.js";
// Vue.use(MessageBox);
export default {
  data: function () {
    return {
      lxdh: "",
      isFocus: false, //搜索按钮是否点击
      isToggle: false, //是否点击侧边栏切换按钮
      userInfo: JSON.parse(sessionStorage.getItem("loginInfo")),
      //userName: JSON.parse(sessionStorage.getItem("loginInfo")).docName,
      //docAvatar: JSON.parse(sessionStorage.getItem("loginInfo")).docAvatar,
      showTime: "", //动态显示的时间
      timeOut: [], //计时器
      version: "",
      //partMsgBoxList: [],
    };
  },
  computed: {
    routerPath: function () {
      return this.$store.state.routerPath;
    },
    // allMsgBoxListCounts: function() { // 未读消息数
    //     return this.$store.state.allMsgBoxListCounts;
    // },
    // partMsgBoxList: function() {
    //    if(this.$store.state.allMsgBoxList.list){
    //         return this.$store.state.allMsgBoxList.list.slice(0, 10);
    //     }else {
    //        return [];
    //     }
    // },
    // allMsgBoxList: function() {
    //     return this.$store.state.allMsgBoxList.list;
    // }
  },
  components: {
    MsgListBoxCmp,
  },
  directives: {
    focus: {
      update: function (el, binding) {
        if (binding.value) {
          el.focus();
        }
      },
    },
  },
  async created() {
    this.lxdh = await systemService.key("HOS_TEL_NUM", 1);
    this.changeTime();
    // this.$store.dispatch("getAllMsgBoxList");// 获取消息盒子列表内容总数
    // this.$store.dispatch("getAllMsgBoxListCounts");// 获取消息盒子未读数
    // this.getVersion();
  },
  beforeDestroy: function () {
    //组件销毁前清除计时器
    if (this.timeOut) {
      clearTimeout(this.timeOut);
      this.timeOut = null;
    }
  },
  methods: {
    // getVersion:function(){
    //     let _this=this;
    //     let options={
    //         Service:"nethos.system.param.string",
    //         key:"VIDEO_SP_HUSHI_PC_VERSION",
    //         defaultString:"1"
    //     }
    //     axiosUtil(options,function(data){
    //         _this.version=data.obj;
    //     })
    // },
    Downloading: function () {
      MessageBox.confirm("是否确认下载视频客户端？", "提示", {
        confirmButtonText: "确定下载",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href =
          "https://nethosweb.diandianys.com/download/ZheBao_Setup.exe";
      });
    },
    changeTime: function () {
      let _this = this;
      _this.timeOut = setInterval(function () {
        _this.showTime = new Date().pattern("yyyy年MM月dd日 HH:mm:ss EEE");
      }, 1000);
    },
    getFocus: function () {
      this.isFocus = true;
    },
    toggleSideBar: function () {
      this.isToggle = !this.isToggle;
      this.$emit("toggleSideBar");
    },
    preClick: function () {
      //点击路由后退按钮
      this.$router.go(-1);
    },
    nextClick: function () {
      //点击路由前进按钮
      this.$router.go(1);
    },
    logout: function (e) {
      //退出登录
      e.stopPropagation();
      let _this = this;
      MessageBox.confirm("确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let options = {
            token: localStorage.getItem("token"),
            Service: "smarthos.user.doc.exit",
          };
          axiosUtil(options, function () {
            let userInfoStr=localStorage.getItem("loginInformation")
            //退出的时候清空缓存,fleet 2023年7月18日
            localStorage.clear()
            sessionStorage.clear()
            if(userInfoStr){
              localStorage.setItem("loginInformation",userInfoStr)
            }
            // _this.$store.dispatch("changeSideItem", "wlmz");
            // window.location = HOST_URL;
            _this.$message.success("退出成功")
            setTimeout(() => {
              _this.$router.push("/login");
            }, 1500);
          });
          //this.$store.dispatch("changeSideItem", "rwzx");
        })
        .catch(() => {});
    },
    linkTo: function (itemJSON) {
      //点击消息下拉菜单 跳转
      MsgBoxListUtils(this, itemJSON);
    },
    dropDownHandler: function () {
      // 获取消息盒子下拉列表数据
      this.$store.dispatch("getAllMsgBoxList", 1);
    },
    linkToHome: function (ev) {
      let e = ev || event;
      if (e.preventDefault) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //停止冒泡
        e.returnValue = false; //阻止事件的默认行为
      }
      this.$router.push("/main");
      this.$store.dispatch("changeSideItem", "rwzx");
    },
    showMsgListBox: function (ev) {
      // 现实消息盒子
      //this.dialogTableVisible = true;
      this.$store.dispatch("isOpenMsgListBox", true); // 打开消息盒子
    },
  },
};
</script>
